<template lang="pug">
  b-form-group(label-cols="3" :label="label" label-align="left" :label-for="id_custom" :description="description")
    b-input-group(:append="sufix")
      b-form-input(:id="id_custom" :name="id_custom" :type='type' v-model="name")
    //.error(v-if="!$v.name.minLength")
      | Name must have at least {{$v.name.$params.minLength.min}} letters.
</template>

<script>

  import { required, minLength, email } from 'vuelidate/lib/validators'

  export default {
    props: ['label','id_custom','type','description','sufix','vueRequired','value'],
    data() {
      return {
        name: ''
      }
    },
    mounted() {
      this.name = this.value;
    },
    watch: {
      name: function (newName, oldName){
        this.$emit('input', newName);
      }
    }
  }
</script>

<style scoped>

</style>